import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import Flatpickr from 'react-flatpickr';
import moment from 'moment';
import Swal from 'sweetalert2';
import IButtonComponent from '../../../components/Common/iComponents/iButton/IButton';

import { useDispatch, useSelector } from 'react-redux';
import { getFilterList } from '../../../store/dashboard/actions';
import {
  getSavedSearchesList,
  saveSearch,
  deleteSearches,
} from '../../../store/SavedSearches/actions';
import { getBrand } from '../../../store/brand/actions';

import {
  Card,
  Col,
  Row,
  CardTitle,
  InputGroup,
  Input,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  Form,
  Label,
  DropdownItem,
  Modal,
} from 'reactstrap';

import 'flatpickr/dist/themes/material_blue.css';
import './filters.scss';
import {
  getToday,
  getThisweek,
  getThisweekToDate,
  getThisMonth,
  getThisMonthToDate,
  getThisYear,
  getThisYearToDate,
  getYesterday,
  getLastWeek,
  getLastWeekToDate,
  getLastMonth,
  getLastMonthToDate,
  getLastThreeMonths,
  getLastSixMonths,
  getLastYear,
  getLastYearToDate,
} from '../../../helpers/dateFuntions';

const Filters = ({
  onSearchClicked,
  filterItems,
  groupName,
  hideDates = false,
  hideView = true
}: any) => {
  const dispatch = useDispatch();
  //const initialFilterState: any[] | (() => any[]) = [];
  const tmpFilterState: any[] | (() => any[]) = [];

  const DatesFilters = [
    'Today',
    'This week',
    'This week to date',
    'This month',
    'This month to date',
    'This year',
    'This year to date',
    'Yesterday',
    'Last week',
    'Last week to date',
    'Last month',
    'Last month to date',
    'Last three months',
    'Last six months',
    'Last year',
    'Last year to date',
  ];

  const [stateFilterDates, setstateFilterDates] = useState('');
  const { filterList, filterData, isLoading } = useSelector(
    (state: any) => state.Dashboard,
  );

  const { savedSearches, savedCompleted } = useSelector(
    (state: any) => state.SavedSearches,
  );

  const [countSearch, setCountSearch] = useState(0);

  const [modalConfirm, setModalConfirm] = useState(false);
  const [modalViewForm, setModalViewForm] = useState({
    action: '',
    isVisible: false,
  });

  const [updatingFilter,setUpdatingFilter] = useState(false)

  const progressBarValue = 0;
  const brand = useSelector((state: any) => state.brand);

  const currentDate = new Date();

  const [fromState, setFromState] = useState<string>(currentDate.toDateString());
  const [toState, setToState] = useState<string>(currentDate.toDateString());

  const [filterState, setFilterState] = useState(filterList);
  const [savedSearchesState, setSavedSearchesState] = useState<any[]>([]);
  const [isFilterOpen, setIsFilterOpen] = useState<boolean>(false);
  const [optionStatus, setOptionStatus] = useState<any[]>([]);
  const [optionLocation, setOptionLocation] = useState<any[]>([]);
  const [optionComodity, setoptionComodity] = useState<any[]>([]);
  const [optionSeller, setOptionSeller] = useState<any[]>([]);
  const [optionBuyer, setOptionBuyer] = useState<any[]>([]);
  const [optionBrand, setOptionBrand] = useState<any[]>([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedLocationOption, setSelectedLocationOption] = useState(null);
  const [selectedComodityOption, setSelectedComodityOption] = useState(null);
  const [selectedSellerOption, setSelectedSellerOptviewFormion] =
    useState(null);
  const [selectedBuyerOption, setSelectedBuyerOption] = useState(null);
  const [selectedBrandOption, setSelectedBrandOption] = useState(null);

  const [filterListItems, setFilterListItems] = useState<any[]>([]);
  const [SearchName, setSearchName] = useState('');
  const [filterCondition, setFilterCondition] = useState<any>({});

  const initialViewFormState = {
    name: '',
    columns: [],
    default: false,
  };
  const [viewForm, setViewForm] = useState<any>(initialViewFormState);

  const [formFilters, setFormFilters] = useState<any>({
    from: moment().format('YYYY-MM-DD'),
    to: moment().format('YYYY-MM-DD'),
  });

  const conditionOptions = [
    {
      id: 1,
      label: "AND",
      value: "AND",
      name: "AND",
    },
    {
      id: 2,
      label: "OR",
      value: "OR",
      name: "OR",
    }

  ]

  const options: Object = {
    chart: {
      height: 40,
      type: 'line',
      toolbar: { show: false },
    },
    fill: {
      colors: ['#1E2585', '#ffe000', '#0e113e'],
    },
    colors: ['#1E2585', '#ffe000', '#0e113e'], //Add this line
    stroke: {
      curve: 'smooth',
      width: 2,
    },
    xaxis: {
      labels: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        show: false,
      },
    },
    tooltip: {
      fixed: {
        enabled: false,
      },
      x: {
        show: false,
      },
      y: {
        title: {
          formatter: function (seriesName: any) {
            return '';
          },
        },
      },
      marker: {
        show: false,
      },
    },
  };

  const donutchartOptions: Object = {
    chart: { type: 'donut' },
    legend: { show: false },
    dataLabels: { enabled: false },
    tooltip: { enabled: true },

    colors: filterData?.orders
      ? filterData?.orders[0].colors
      : ['#1E2585', '#ffe000', '#0e113e'],
    //color: ["#1E2585", "#ffe000","#0e113e"],
    labels: ['One', 'Two', '', '', '', '', '', '', '', '', '', ''],
    stroke: { width: 0 },
    states: {
      hover: {
        filter: {
          type: 'lighten',
          value: 0.08,
        },
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          dataLabels: {
            enabled: true,
          },
          legend: {
            position: 'top',
          },
        },
      },
    ],
  };

  useEffect(() => {
    if (filterItems == null || filterItems === undefined) return;

    const filters: any = JSON.parse(localStorage.getItem("filterOperation") || "{}");
    const listfilter = filterItems.filter((column: any) => column.showInFilters === true);

    if (countSearch < 1) {
      // First load: initialize form values and conditions from localStorage
      const newFilterConditions: any = {};
      listfilter.forEach((column: any) => {
        let value = '';
        if (filters[groupName]) {
          value = filters[groupName][column.dataField];
        }
        setFormFilters((prev: any) => ({ ...prev, [column.dataField]: value }));
        newFilterConditions[column.dataField] =
          filters[groupName]?.Conditions?.[column.dataField] || conditionOptions[0];
      });
      setFilterCondition(newFilterConditions);

      let newFilterListItems: any[] = listfilter;
      if (filters[groupName]) {
        newFilterListItems = listfilter.map((item: any) => {
          if (filters[groupName][item.dataField]) {
            item.selectedOption = filters[groupName][item.dataField];
          }
          return item;
        });
      }
      setFilterListItems(newFilterListItems);

      if (SearchName !== '' && SearchName !== undefined) {
        handleViewSelectChange(SearchName);
      }
    } else {
      // After first search: always refresh options (data) from new filterItems,
      // but preserve any selectedOption the user has already set.
      setFilterListItems((prev: any[]) =>
        listfilter.map((item: any) => {
          const existing = (prev || []).find((f: any) => f.dataField === item.dataField);
          return existing
            ? { ...item, selectedOption: existing.selectedOption }
            : item;
        })
      );
    }
  }, [filterItems]);

  useEffect(() => {
    if (savedCompleted) {
      Swal.fire('Save Successfully', 'items saved', 'success').then(
        (result) => {
          if (result.isConfirmed) {
            dispatch(getSavedSearchesList({ groupName }));
            setModalViewForm({
              action: 'new',
              isVisible: false,
            });
          }
        },
      );
    }
  }, [savedCompleted]);

  useEffect(() => {
    setSavedSearchesState(savedSearches);
    //setSavedSearchesState(savedSearches);
  }, [savedSearches]);

  const handleSaveSearch = (inputData: any,isUpdate?:any) => {
    Swal.fire({
      title: 'Do you want to save ?',
      showDenyButton: true,
      confirmButtonText: 'Yes',
      denyButtonText: 'Cancel',
      allowEscapeKey: false,
      allowOutsideClick: false,
      customClass: {
        actions: 'my-actions',
        cancelButton: 'order-1 right-gap',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        if(isUpdate){
          setUpdatingFilter(false)
        }
        //showProgress();
        dispatch(saveSearch(inputData));
      }
      else if(isUpdate){
        setUpdatingFilter(false)
        handleViewSelectChange(SearchName)
      }
    });
  };

  const handleDeleteSearch = () => {
    Swal.fire({
      title: 'Do you want to delete ?',
      showDenyButton: true,
      confirmButtonText: 'Yes',
      denyButtonText: 'Cancel',
      allowEscapeKey: false,
      allowOutsideClick: false,
      customClass: {
        actions: 'my-actions',
        cancelButton: 'order-1 right-gap',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        //showProgress();
        dispatch(deleteSearches(handleModalConfirm()));
        const value = savedSearchesState?.length ? 'Default' : '';
        setSearchName(value);
        handleViewSelectChange(value);
        Swal.fire('Delete Successfully', 'items saved', 'success').then(
          (result) => {
            if (result.isConfirmed) {
              // ESTA HACIENDO EL LLENANDO DE LA ACCION
              dispatch(getSavedSearchesList({ groupName }));
              setModalViewForm({
                action: 'new',
                isVisible: false,
              });
            }
          },
        );
      }
    });
  };

  const renderButtons = () => (
    <>
      <IButtonComponent
        className="btn-search"
        actionOnClick={() => {
          const newFilter = {...reorderObjectByReference(formFilters),[`Conditions`]:filterCondition};
          setCountSearch(countSearch + 1);
          onSearchClicked(newFilter);
          const filters:any = JSON.parse(localStorage.getItem("filterOperation") || "{}");
          if(groupName){
            localStorage.setItem("filterOperation",JSON.stringify({
              ...filters,
              [groupName]: newFilter,
              
            }))
          }
        }}
        label={'Search'}
        btnIcon="bx bx-search"
      ></IButtonComponent>

      <IButtonComponent
        className="btn-cancel-search"
        actionOnClick={() => {
          //setSearchName("Default");
          handleViewSelectChange('Default');
        }}
        label={'Clear'}
        btnIcon="bx bx-search"
      ></IButtonComponent>
    </>
  );

  const renderSelect = (
    name: string,
    title: string,
    dataField: string,
    selected: any,
    options: any,
    conditionalIsLocked?:any,
  ) => {
    return (
      <Col xl={3} md={6}>
        <CardTitle className="card-title mb-4 FilterTitle">{title}</CardTitle>
        <div className=' d-flex justify-content-start align-content-center'>
        <Col   xl={8} md={8} xs={8}>
          <Select
            value={selected ? selected: []}
            isMulti={true}
            onChange={(selectedOption: any) => {
              handleListChange(dataField, selectedOption);
            }}
            options={options}
            classNamePrefix="select2-selection"
          />
        </Col>

        <Col className='SelectConditionTheFilter' xl={4} md={4} xs={4}>
          <Select
              value={filterCondition[dataField]}
              isDisabled={conditionalIsLocked}
              isMulti={false}
              onChange={(selectedOption: any) => {
                handleFilterConditions(selectedOption,dataField)
              }}
              options={conditionOptions}
              classNamePrefix="select2-selection"
            />
        </Col>

        </div>

      </Col>
    );
  };

  
  const handleFilterConditions = (change:any, key:any)=>{
    setFilterCondition({
      ...filterCondition,
      [key]:change
    })
  }

  const renderInput = (
    name: string,
    title: string,
    dataField: any,
    options: any,
    setStateFunction: any,
  ) => {
    return (
      <Col xl={3} md={6}>
        <CardTitle className="card-title mb-4">{title}</CardTitle>
        <Input
          placeholder={`Filter ${name}`}
          className="mb-3"
          onChange={(event: any) => {
            const newForm = { ...formFilters, [dataField]: event.target.value };
            setFormFilters(newForm);
          }}
        />
      </Col>
    );
  };

  useEffect(() => {
    dispatch(getFilterList());
    dispatch(getBrand());
    dispatch(getSavedSearchesList({ groupName }));
  }, []);


  useEffect(()=>{
    const filters:any = JSON.parse(localStorage.getItem("filterOperation") || "{}");
    if(filters[groupName]){
      setFormFilters(filters[groupName]);
      if(!hideDates){
        setFromState(moment(filters[groupName].from).format('ddd MMM D YYYY'));
        setToState(moment(filters[groupName].to).format('ddd MMM D YYYY'));
     }
  }
},[])

  useEffect(() => {
    if (filterList) {
      filterList.map((filter: any) => {
        if (filter.name === 'status') {
          const options = filter.data.map((filter: any) => {
            return {
              id: filter.id,
              label: filter.name,
              value: filter.name,
            };
          });
          setOptionStatus([{ options }]);
        }

        if (filter.name === 'whLocation') {
          const optionsLocation = filter.data.map((filter: any) => {
            return {
              id: filter.id,
              label: filter.name,
              value: filter.name,
            };
          });
          setOptionLocation([{ options: optionsLocation }]);
        }

        if (filter.name === 'comodityType') {
          const optionsComodity = filter.data.map((filter: any) => {
            return {
              id: filter.id,
              label: filter.name,
              value: filter.name,
            };
          });
          setoptionComodity([{ options: optionsComodity }]);
        }

        if (filter.name === 'seller') {
          const optionsSeller = filter.data.map((filter: any) => {
            return {
              id: filter.id,
              label: filter.name,
              value: filter.name,
            };
          });
          setOptionSeller([{ options: optionsSeller }]);
        }

        if (filter.name === 'buyer') {
          const optionsBuyer = filter.data.map((filter: any) => {
            return {
              id: filter.id,
              label: filter.name,
              value: filter.name,
            };
          });
          setOptionBuyer([{ options: optionsBuyer }]);
        }

        if (filter.name === 'brand') {
          const optionsBrand = filter.data.map((filter: any) => {
            return {
              id: filter.id,
              label: filter.name,
              value: filter.name,
            };
          });
          setOptionBrand([{ options: optionsBrand }]);
        }
      });
    }
  }, [filterList]);

  useEffect(() => {
    setFilterState(filterList);
  }, [filterList]);

  useEffect(() => {
    if (filterData?.orders) {
      filterData.orders = filterData?.orders.map((obj: any) => {
        obj.options = { ...donutchartOptions };
        obj.options.labels = obj.labels;
        return obj;
      });
    }
  }, [filterData]);

  const timerInterval = 0;


  const handleDateChange = (filter: string, date: any) => {
    setstateFilterDates('');
    if (filter == 'From') {
      setFromState(date);
    } else {
      setToState(date);
    }
    const prop = filter.replace(/ /g, '').toLowerCase();
    const dateFormated = moment(date).format('YYYY-MM-DD');
    const newForm = { ...formFilters, [prop]: dateFormated };
    setFormFilters(newForm);
  };

  const handleDateChangeInputFilter = (from: any, to: any) => {
    setFromState(from);
    setToState(to);
    const fromNew = moment(from).format('YYYY-MM-DD');
    const toNew = moment(to).format('YYYY-MM-DD');
    const newState = { ...formFilters, from: fromNew, to: toNew };
    setFormFilters(newState);
  };

  const handleListChange = (filter: any, item: any) => {
    let newFilterListItems: React.SetStateAction<any[]> = [];
    newFilterListItems = filterListItems.map((itemMap: any) => {
      if (itemMap.dataField == filter) {
        itemMap.selectedOption = item;
      }
      return itemMap;
    });
    const newForm = { ...formFilters, [filter]: item };
    setFormFilters(newForm);
  };


  const formatDataValues = ()=>{
    const datavalues: { dataField: string; values: [] }[] = [];
      if(stateFilterDates){
        const value:any = [stateFilterDates];
        const obj = {
          dataField: "dynamicDates",
          values: value,
        };
        datavalues.push(obj)
      }
      Object.keys(formFilters).forEach((key: string) => {
        if((key == "to" || key == "from") && stateFilterDates){return}
        const data: [] = formFilters[key];
        if (data && data.length > 0) {
          const obj = {
            dataField: key,
            values: data, //JSON.stringify(data)//.replace(/"([^"]+)":/g, '$1:')
          };
          datavalues.push(obj);
        }
      });

      return datavalues;
  }

  const handleModalConfirmButton = () => {
    if (viewForm.name != '') {
      setSearchName(viewForm.name);
      const datavalues = formatDataValues();
      const newViewForm = {
        ...viewForm,
        groupName,
        dataFields: JSON.stringify(datavalues), //.replace(/"([^"]+)":/g, '$1:')
      };
      setViewForm(newViewForm);
      handleSaveSearch(newViewForm);
    }
  };

  const handleModalConfirm = () => {
    setModalConfirm(!modalConfirm);
    const filterName = savedSearches.find(
      (value: any) => value.name === SearchName,
    );
    return filterName;
  };

  const getFilter = () => {
    const filterName = savedSearches.find(
      (value: any) => value.name === SearchName,
    );
    return filterName;
  };

  const handleModalViewForm = ({ action, isVisible }: any) => {
    setViewForm(initialViewFormState);

    if (action === 'edit') {
      const uploadForm = {};
      const data = { ...uploadForm };
    }
    setModalViewForm({
      action,
      isVisible,
    });
  };

  const handleViewForm = (data: any) => {
    setViewForm(data);
  };

  const handleViewSelectChange = (name: any) => {
    setSearchName(name);
    if (name !== '' && name !== 'Default') {
      const filter = savedSearches.find((value: any) => value.name === name);
      const { dataFields }: { dataFields: string } = filter;
      const listDatafields = JSON.parse(dataFields.replaceAll("'", '"'));
      setFromState('');
      setToState('');
      let tmpObj = {
        from: '',
        to: '',
      };
      setFilterListItems(
        filterListItems.map((item: any) => {
          item.selectedOption = '';
          return item;
        }),
      ); //clean selected items
      let newFilterListItems: React.SetStateAction<any[]> = [];
      let flag = false;
      Object.keys(listDatafields).forEach((key: string) => {
        const { dataField, values }: { dataField: string; values: string } =
          listDatafields[key];
        if(dataField == "dynamicDates"){
          flag = true;
          const {from,to} = handleDateFilters(values[0]);
          setstateFilterDates(values[0]);
          const fromDate = new Date(from);
          const toDate = new Date(to);
          tmpObj.from = `${String(fromDate.getFullYear())}-${String(fromDate.getMonth() + 1).padStart(2, '0')}-${String(fromDate.getDate()).padStart(2, '0')}`;
          tmpObj.to = `${String(toDate.getFullYear())}-${String(toDate.getMonth() + 1).padStart(2, '0')}-${String(toDate.getDate()).padStart(2, '0')}`;
        }else{
          if(!flag){
            if (dataField == 'from') {
              setFromState(moment(values).format('MM-DD-YYYY'));
              tmpObj.from = values;
            } else if (dataField == 'to') {
              setToState(moment(values).format('MM-DD-YYYY'));
              tmpObj.to = moment(values).format('YYYY-MM-DD');
            } 
          }
          if(dataField != "from" && dataField != "to"){
            newFilterListItems = filterListItems.map((item: any) => {
              if (item.dataField == dataField) {
                tmpObj = { ...tmpObj, [dataField]: values };
                item.selectedOption = values;
              }
              return item;
            });
            setFilterListItems(newFilterListItems);
          }
        }
      });
      const newForm = { ...tmpObj };
      setFormFilters(newForm);
    } else {
      setFilterListItems(
        filterListItems.map((item: any) => {
          item.selectedOption = '';
          return item;
        }),
      );
      const formCleaned = {
        from: moment().format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD'),
      };
      //setFormFilters(formCleaned);
      const newForm = { ...formCleaned };
      setFormFilters(newForm);
      setFromState(currentDate.toDateString());
      setToState(currentDate.toDateString());
    }
  };

  const filterCheckItems = (items: any, filterItem: any) => {
    const filtered = items.filter(
      (itemSearch: any) =>
        itemSearch.name?.toUpperCase().includes(filterItem.toUpperCase()),
    );
    return filtered;
  };

  const preRenderFilterList = () => {

    const newState = filterState.map((obj: any) => {
      if (obj?.dataTmp) {
        obj.data = obj.dataTmp;
      }
      return obj;
    });
    setFilterState(newState);
  };

  const renderViewDropdown = () => {
    return (
      <UncontrolledDropdown>
        <select
          defaultValue={SearchName}
          className="form-select"
          onChange={(e) => {
            handleViewSelectChange(e.target.value);
          }}
        >
          <option
            disabled={savedSearchesState?.length ? true : false}
            selected={SearchName === ''}
            value=""
          >
            Select Search
          </option>
          {savedSearchesState?.length ? (
            <option selected={SearchName === 'Default'} value="Default">
              Default
            </option>
          ) : null}
          {savedSearchesState
            ? savedSearchesState
                .map((option: any, index: number) => {
                  return (
                    <option
                      value={option.value}
                      selected={SearchName === option.name}
                    >
                      {option.name}
                    </option>
                  );
                })
                .sort()
            : null}
        </select>
      </UncontrolledDropdown>
    );
  };

  const renderModalViewForm = () => (
    <Modal
      isOpen={modalViewForm.isVisible}
      toggle={() => {
        handleModalViewForm({ action: '', isVisible: false });
      }}
      modalViewForm
    >
      <div className="modal-header">
        <h5 className="modal-title mt-0" id="myModalLabel">
          Save Search
        </h5>
        <button
          type="button"
          onClick={() => {
            handleModalViewForm({ action: '', isVisible: false });
          }}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <Form>
          <div className="mb-2">
            <Label className="form-label" htmlFor="viewName">
              Name
            </Label>
            <Input
              type="text"
              className="form-control"
              id="viewName"
              defaultValue={viewForm.name}
              readonly={modalViewForm.action === 'edit'}
              onChange={(e) => {
                handleViewForm({ ...viewForm, name: e.target.value });
              }}
            />
          </div>
        </Form>
      </div>
      <div className="modal-footer">
        <button
          type="button"
          onClick={() => {
            handleModalViewForm({ action: '', isVisible: false });
          }}
          className="btn btn-secondary "
          data-dismiss="modal"
        >
          Close
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => {
            handleModalConfirmButton();

            handleModalViewForm({ action: '', isVisible: false });
          }}
        >
          {modalViewForm.action === 'edit' ? 'Update' : 'Create'}
        </button>
      </div>
    </Modal>
  );
  //---------------------------------------------------

  const handleDateFilters = (title: any) => {
    let ToFrom: any = '';
    switch (title) {
      case 'Today':
        ToFrom = getToday();
        break;
      case 'This week':
        ToFrom = getThisweek();
        break;
      case 'This week to date':
        ToFrom = getThisweekToDate();
        break;
      case 'This month':
        ToFrom = getThisMonth();
        break;
      case 'This month to date':
        ToFrom = getThisMonthToDate();
        break;
      case 'This year':
        ToFrom = getThisYear();
        break;
      case 'This year to date':
        ToFrom = getThisYearToDate();
        break;
      case 'Yesterday':
        ToFrom = getYesterday();
        break;
      case 'Last week':
        ToFrom = getLastWeek();
        break;
      case 'Last week to date':
        ToFrom = getLastWeekToDate();
        break;
      case 'Last month':
        ToFrom = getLastMonth();
        break;
      case 'Last month to date':
        ToFrom = getLastMonthToDate();
        break;
      case 'Last three months':
        ToFrom = getLastThreeMonths();
        break;
      case 'Last six months':
        ToFrom = getLastSixMonths();
        break;
      case 'Last year':
        ToFrom = getLastYear();
        break;
      case 'Last year to date':
        ToFrom = getLastYearToDate();
        break;
    }
    if (ToFrom != '') {
      handleDateChangeInputFilter(ToFrom.from, ToFrom.to);
    }
    return {to: ToFrom.to, from: ToFrom.from}
  };


  const handleSaveFilterSearch = ()=>{
    const datavalues = formatDataValues();
      const {name,groupName,id}:any = getFilter();
      const newViewForm = {
        name,
        groupName,
        dataFields: JSON.stringify(datavalues),
        id //.replace(/"([^"]+)":/g, '$1:')
      };
      setViewForm(newViewForm);
      handleSaveSearch(newViewForm,true);
  }

  //---------------------------------------------------
  const renderViewActions = () => (
    <UncontrolledDropdown direction="down">
      <DropdownToggle type="button" className="btn btn-secondary">
        <i className="mdi mdi-cog"></i>
      </DropdownToggle>
      <DropdownMenu className="dropdownmenu-secondary floatSettings position-absolute flex-wrap">
        <DropdownItem to="#">
          <div
            onClick={() => {
              handleModalViewForm({ action: 'new', isVisible: true });
            }}
          >
            New
          </div>
        </DropdownItem>
        {SearchName ? (
          <DropdownItem to="#">
            <div onClick={handleDeleteSearch}>Delete</div>
          </DropdownItem>
        ) : null}
        {SearchName && !updatingFilter ? (
          <DropdownItem to="#">
            <div onClick={()=>{setUpdatingFilter(true)}}>Update</div>
          </DropdownItem>
        ) : null}
        {SearchName && updatingFilter ? (
          <DropdownItem to="#">
            <div onClick={handleSaveFilterSearch}>Save</div>
          </DropdownItem>
        ) : null}
      </DropdownMenu>
    </UncontrolledDropdown>
  );

  const FiltersDatesInput = (title: any) => {
    if (title == 'From') {
      return (
        <div className="InputFilterDates">
          <UncontrolledDropdown>
            <select
              className="form-select"
              onChange={(e) => {
                handleDateFilters(e.target.value);
                setstateFilterDates(e.target.value);
              }}
              value={stateFilterDates}
            >
              <option
                disabled={savedSearchesState?.length ? true : false}
                selected={stateFilterDates === ''}
                value=""
              ></option>
              {savedSearchesState
                ? DatesFilters.map((option: any) => {
                    return (
                      <option
                        value={option}
                        selected={stateFilterDates === option}
                      >
                        {option}
                      </option>
                    );
                  }).sort()
                : null}
            </select>
          </UncontrolledDropdown>
        </div>
      );
    }
  };

  const renderDate = (title: string, value: string) => (
    <Col xl={3} md={6}>
      <CardTitle className="card-title mb-4 FilterTitle">{title}</CardTitle>
      <InputGroup>
        <Flatpickr
          value={new Date(value)}
          className="form-control d-block"
          placeholder="mm-dd-yyyy"
          itemKey={title}
          options={{
            altInput: true,
            altFormat: 'F j, Y',
            dateFormat: 'mm-dd-yyyy',
            minDate: new Date('2022-01-01'),
            //maxDate: "today",
          }}
          onChange={(date: any) => {
            handleDateChange(title, date[0]);
          }}
        />
        {FiltersDatesInput(title)}
      </InputGroup>
    </Col>
  );

  function reorderObjectByReference(originalObject: any): any {
    let orderedObject: any = {};
  
    filterListItems.forEach((item: any) => {
      const key = item.dataField;
      if (originalObject[key]) {
        orderedObject = {
          ...orderedObject,
          [key]: originalObject[key]
        };
      }
    });
  
    Object.keys(originalObject).forEach(key => {
      if (!orderedObject[key]) {
        orderedObject = {
          ...orderedObject,
          [key]: originalObject[key]
        };
      }
    });
    return orderedObject;
  }
  

  const renderFilterList = () => {
    return (
      <Row md={4} className="filterListCard">
        {!hideDates ? (
          <>
            {renderDate('From', fromState)}
            {renderDate('To', toState)}
          </>
        ) : null}

        {filterListItems.length > 0
          ? filterListItems.map((filter: any, index: any) => {
              const { text, name, data, dataField, selectedOption } = filter;
              const nextFilter = index < filterListItems.length - 1 ? filterListItems[index + 1] : null;
              let conditionalIsLocked = false;
                if (
                  dataField.startsWith('CF') ||
                  dataField.startsWith('SOCF') ||
                  dataField.startsWith('POCF') ||
                  dataField.startsWith('CRCF') ||
                  dataField.startsWith('WRCF')
              ){
                conditionalIsLocked = true;
              }else{
                if(nextFilter){
                  const {dataField} = nextFilter;
                  if (
                    dataField.startsWith('CF') ||
                    dataField.startsWith('SOCF') ||
                    dataField.startsWith('POCF') ||
                    dataField.startsWith('CRCF') ||
                    dataField.startsWith('WRCF')
                ){
                  conditionalIsLocked = true;
                }
                }
              }
              const options = data.map((filter: any) => {
                return {
                  id: filter.id,
                  label: filter.name,
                  value: filter.name,
                  name: filter.name,
                };
              });
              return (
                <>
                  {renderSelect(text, text, dataField, selectedOption, options,conditionalIsLocked)}
                </>
              );
            })
          : null}
      </Row>
    );
  };

  return (
    <React.Fragment>
      <Card>
        <Col xl={12}>
          {hideView && (
            <div className="d-flex flex-wrap gap-2 justify-content-end pt-2">
            <>
              {renderModalViewForm()}
              {renderViewDropdown()}
              {renderViewActions()}
            </>
          </div>
          )}
        </Col>

        <Row>
          {renderFilterList()}
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginTop: '1%',
              marginRight: '1%',
            }}
          >
            {renderButtons()}
          </div>
        </Row>
      </Card>
      <div className="container">
        <>{/* {isLoading ? null : hideProgress()} */}</>
      </div>
    </React.Fragment>
  );
};

export default Filters;

Filters.propTypes = {
  onSearchClicked: PropTypes.func,
  filterItems: PropTypes.array,
  groupName: PropTypes.string,
  hideDates: PropTypes.bool,
  hideView: PropTypes.bool,
};
